import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { ChangeEvent, useContext, useEffect, useState } from "react";
import { SuccessAlertContext } from "App";
import { emailReceiveSettingApi, getEmailReceiveSettingApi } from "../api/emailReceiveSettingApi";
import { mapReversedElements } from "../utils/common";

type Props = {
  open: boolean;
  onClose: Function;
};

type RadioIndex = 0 | 1;

const radioOptions = [
  "受け取らない",
  "受け取る",
] as const;

/**
 * 出荷情報設定モーダル
 * @param root0 コンポーネントのプロップス
 */
export default function ReceiveEmailSetting({ open, onClose }: Props) {
  const [emailMode, setEmailMode] = useState<RadioIndex>(0);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const { showAlert } = useContext(SuccessAlertContext);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const index = parseInt(e.target.value, 10) as RadioIndex;
    setSelectedIndex(index);
    setEmailMode(index);
  };

  useEffect(() => {
    (async () => {
      if (open) {
        setIsLoading(true);
        try {
          const {mode} = await getEmailReceiveSettingApi();
          setSelectedIndex(mode);
          setEmailMode(mode);
        } catch (err) {
          console.error(err);
        } finally {
          setIsLoading(false);
        }
      }
    })();
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={() => onClose()}
      PaperProps={{
        sx: {
          minWidth: 550,
          maxWidth: 1200,
        },
      }}
    >
      <DialogTitle>メール受信設定</DialogTitle>
      <DialogContent>
        <Grid container direction="column" spacing={2}>
          {/* タイトル */}
          <Grid item>
            <Typography ml={2} color="rgb(50,50,50)">
              受注通知を受け取りますか？
            </Typography>
          </Grid>
          {/* フォーム */}
          <Grid item container justifyContent="center">
            <Grid item textAlign="center" justifyItems="center" my={1} mr={0}>
              <FormControl component="fieldset">
                <RadioGroup value={String(selectedIndex)} onChange={handleChange}>
                  { mapReversedElements(radioOptions, (o, i) => (
                    <FormControlLabel
                      // eslint-disable-next-line react/no-array-index-key
                      key={i}
                      value={String(i)}
                      control={<Radio />}
                      label={o}
                    />
                  ))}
                  {/* {[...radioOptions].map((o, i) => (
                    <FormControlLabel
                      // eslint-disable-next-line react/no-array-index-key
                      key={i}
                      value={String(i)}
                      control={<Radio />}
                      label={o}
                    />
                  ))} */}
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="custom-outlined" onClick={() => onClose()}>
          キャンセル
        </Button>
        <Button
          variant="contained"
          onClick={async () => {
            setIsLoading(true);
            try {
              await emailReceiveSettingApi({
                mode: emailMode,
              });
              showAlert('メール受信を設定しました。', 'success')
            } catch (err) {
              console.error(err);
            } finally {
              setIsLoading(false);
            }
            onClose();
          }}
        >
          設定
        </Button>
      </DialogActions>
      {isLoading && ( // マスク
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            bgcolor: "rgba(0,0,0,0.2)",
            zIndex: (theme) => theme.zIndex.modal + 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      )}
    </Dialog>
  );
}
